import { DaoModel } from '@dynameat/models';

export class FrontMenuProductDynamicData extends DaoModel {
  constructor(guid, menuProductGuid, productGuid, productName, serviceGuid, date, special, order, isVisible) {
    super(guid);
    this.menuProductGuid = menuProductGuid || '';
    this.productGuid = productGuid || '';
    this.productName = productName || '';
    this.serviceGuid = serviceGuid || '';
    this.date = date || null;
    this.special = special || false;
    this.order = order + 1 || 1; // one-indexed in front, zero-indexed in back
    this.isVisible = isVisible || false;
    this.oldSpecial = this.special;
    this.oldOrder = this.order;
    this.oldIsVisible = this.isVisible;
  }

  static toInstance(props = {}) {
    return new FrontMenuProductDynamicData(props.guid, props.menu_product_guid, props.product_guid,
      props.product_name, props.service_guid, props.date, props.special, props.order, props.is_visible);
  }

  serialize() {
    return {
      ...super.serialize(),
      menu_product_guid: this.menuProductGuid,
      product_guid: this.productGuid,
      product_name: this.productName,
      service_guid: this.serviceGuid,
      date: this.date,
      special: this.special,
      order: this.order - 1, // one-indexed in front, zero-indexed in back
      is_visible: this.isVisible
    };
  }

  changeSpecial(newValue) {
    this.special = newValue;
  }

  changeOrder(newOrder) {
    this.order = newOrder;
  }

  changeIsVisible(newIsVisible) {
    this.isVisible = newIsVisible;
  }

  hasChanged() {
    return this.order !== this.oldOrder || this.special !== this.oldSpecial
      || this.isVisible !== this.oldIsVisible;
  }
}
